import React from 'react';
import BttfAxios from '@features/utils/axios';
import Select from 'react-select';
import IInvestorSearch, { TInvestorSearch } from './IInvestorSearch';

import * as style from './InvestorSearchStyles.module.scss'
import * as elements from '@appStyles/_elements.module.scss';

class Search extends React.Component<IInvestorSearch, TInvestorSearch> {

  state: TInvestorSearch = {
    options: [],
    selected: [],
    isLoading: false,
    showBtn: false,
    type: 'Profile',
  };

  getValue = (value: string) => {
    if (value.length > 2) {
      this.setState({ isLoading: true });
      BttfAxios.get(`/api/search/investors?q=${value}&type=${this.state.type}`, (res) => {
        const data = res.data.map((elem: any) => {
          elem.value = elem.name;
          elem.label = elem.name;

          return elem;
        });
        this.setState({ options: data, isLoading: false });
      });
    }
  }

  getAllValues = (all: any) => {
    if (all.length === 0) {
      this.setState({ showBtn: false });
    } else this.setState({ showBtn: true, selected: all });
  }

  addPeople = () => {
    this.props.btnCallback(this.state.selected);
    this.setState({ selected: [], showBtn: false });
  }

  radioChange = (e: any) => {
    this.setState({ type: e.target.value, options: [] });
  }

  render() {
    return (
      <div className={style.search}>
        <div className={style.searchOptions}>
          <h3 className={style.searchOptionsHeadline}>Search investors by:</h3>
          <div className={[elements.customRadio, style.searchOptionsHolder].join(' ')}>
            <input
              onChange={this.radioChange}
              id="searchType1"
              type="radio"
              name="type"
              value="Company"
              checked={this.state.type === 'Company'}
            />
            <label htmlFor="searchType1">Company</label>
          </div>
          <div className={[elements.customRadio, style.searchOptionsHolder].join(' ')}>
            <input
              onChange={this.radioChange}
              id="searchType2"
              type="radio"
              name="type"
              value="Profile"
              checked={this.state.type === 'Profile'}
            />
            <label htmlFor="searchType2">Profile</label>
          </div>
        </div>
        <div className={style.searchSelect}>
          <Select
            options={this.state.options}
            onChange={this.getAllValues}
            onInputChange={this.getValue}
            isLoading={this.state.isLoading}
            filterOption={() => (true)}
            value={this.state.selected}
          />
          {this.state.showBtn && <button onClick={this.addPeople} className={style.searchBtn}>Add to investors</button>}
        </div>
      </div>
    );
  }
}

export default Search;
